import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, Select, Button, DatePicker } from 'antd';
import SearchRetrieve from '../common/SearchRetrieve';
import SelectProvince from '../common/SelectProvince';
import TableC from '../basicElement/TableC';
import $ from '../../common/AjaxRequest';
import ExportUtil from '../../common/ExportUtil';
import PreviewModal from './PreviewModal';
import API_URL from '../../common/url';
import moment from 'moment';
import UserSider from './UserSider';
import { saveParams } from '../../actions/PersonalActions';
import { saveParams as saveNoticeParams } from '../../actions/noticeActions';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        searchParams: {
            workStatus: 'WORKING',
        },
    }

    componentDidMount() {
        const { searchParams } = this.state;
        const { noticeParams = {} } = this.props;
        const { employeeCode } = noticeParams;
        this.setState({
            searchParams: {
                ...searchParams,
                employeeCode,
            }
        }, () => {
            this.search();
        })
    }

    search = () => {
        const {
            searchParams,
            searchParams: {
                areaParams,
            },
        } = this.state;
        this.props.search({ ...searchParams, ...areaParams, areaParams: '', hasCheckedArea: '' });
    }

    export = () => {
        this.props.export();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleDateChange = (data, dateString, field) => {
        const { searchParams } = this.state;
        searchParams[field] = dateString;
        this.setState({ searchParams });
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.map(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    handleChange = (type, value, options, isLoading) => {
        const { searchParams } = this.state;
        const { key, label } = value || {};
        const obj = {};
        if (type === 'department') {
            searchParams.enterpriseDepartmentId = key;
            searchParams.enterpriseDepartmentName = label;
            searchParams.positionId = '';
            searchParams.positionName = '';
            obj.departmentOptions = options;
            obj.positionOptions = [];
        } else if (type === 'xjDept') {
            searchParams.xjDeptId = key;
            searchParams.xjDeptName = label;
            obj.xjDeptOptions = options;
        } else if (type === 'xxjDept') {
            searchParams.xxjDeptId = key;
            searchParams.xxjDeptName = label;
            obj.xxjDeptOptions = options;
        } else if (type === 'position') {
            searchParams.positionId = key;
            searchParams.positionName = label;
            obj.positionOptions = options;
        } else if (type === 'leader') {
            searchParams.leaderId = key;
            searchParams.leaderName = label;
            obj.leaderOptions = options;
        } else if (type === 'hospital') {
            searchParams.hospitalId = key;
            searchParams.hospitalName = label;
            obj.hospitalOptions = options;
        }
        this.setState({
            ...obj,
            searchParams,
        });
    }

    render() {
        const {
            searchParams: {
                joinTime,
                positiveTime,
                employeeCode,
                userCompellation,
                companyName,
                areaName,
                workStatus,
                hasCheckedArea = [],
                enterpriseDepartmentId,
                enterpriseDepartmentName,
                xjDeptId,
                xjDeptName,
                xxjDeptId,
                xxjDeptName,
                positionId,
                positionName,
                leaderId,
                leaderName,
                hospitalId,
                hospitalName,
            },
            xjDeptOptions = [],
            xxjDeptOptions = [],
            positionOptions = [],
            leaderOptions = [],
            hospitalOptions = [],
        } = this.state;
        const newJoinTime = joinTime ? moment(joinTime) : null;
        const newPositiveTime = positiveTime ? moment(positiveTime) : null;
        const departmentValue = enterpriseDepartmentId ? { key: String(enterpriseDepartmentId), label: enterpriseDepartmentName } : {};
        const xjDeptValue = xjDeptId ? { key: String(xjDeptId), label: xjDeptName } : {};
        const xxjDeptValue = xxjDeptId ? { key: String(xxjDeptId), label: xxjDeptName } : {};
        const positionValue = positionId ? { key: String(positionId), label: positionName } : {};
        const leaderValue = leaderId ? { key: String(leaderId), label: leaderName } : {};
        const hospitalValue = hospitalId ? { key: String(hospitalId), label: hospitalName } : {};
        return (
            <div className="search-bar" style={{ marginBottom: 20 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        style={{ width: 120 }}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        style={{ width: 120 }}
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">部门</label>
                    <SearchRetrieve
                        type="department"
                        keyword="keyword"
                        style={{ width: 142 }}
                        placeholder="输入部门检索"
                        value={departmentValue}
                        data={[{
                            text:'临床肿瘤事业部',
                            value:99
                        }, {
                            text:'临床非肿瘤事业部',
                            value:100
                        }, {
                            text:'临床综合事业部',
                            value:101
                        }, {
                            text:'临床资源部',
                            value:102
                        }, {
                            text:'临床部',
                            value:41
                        }, {
                            text:'津石医药临床部',
                            value:1
                        },  {
                            text:'药明津石临床部',
                            value:68
                        }]}
                        params={{ limit: 20 }}
                        url={API_URL.user.queryUserDepartmentSelect}
                        config={{ id: 'enterpriseDepartmentId', name: 'enterpriseDepartmentName' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">职位级别</label>
                    <SearchRetrieve
                        type="position"
                        keyword='positionName'
                        style={{ width: 142 }}
                        placeholder="输入职位检索"
                        value={positionValue}
                        data={positionOptions}
                        disabled={!enterpriseDepartmentId}
                        params={{ limit: 20, enterpriseDepartmentId }}
                        url={API_URL.team.queryUserPositionSelect}
                        config={{ id: 'positionId', name: 'positionName' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="search-item">
                    <label className="ui-label">区域/城市</label>
                    <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                </div>
                <div className="search-item">
                    <label className="ui-label">主管领导</label>
                    <SearchRetrieve
                        type="leader"
                        keyword='keyword'
                        style={{ width: 142 }}
                        placeholder="输入姓名/工号检索"
                        value={leaderValue}
                        data={leaderOptions}
                        params={{ limit: 20 }}
                        url={API_URL.user.queryEmpVitaeUserList}
                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                    <Button type="primary" onClick={this.export}>导出</Button>
                </div>
            </div>
        );
    }
}

class UserResume extends React.Component {
    state = {
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
        data: [],
    }

    componentWillUnmount() {
        this.props.saveNoticeParams({
            employeeCode: undefined,
        });
    }
    
    search = (params) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const params = {
            ...sortParams,
            ...searchParams,
        }
        ExportUtil.export(params, pagination, API_URL.user.exportEmpVitaeList);
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.getEmpVitaeList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                positionId: '',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    getDateRender = text => text ? text.slice(0, 10) : ''

    getColumns = () => {
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            // sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            // sorter: true,
            width: 60,
        }, {
            title: '部门',
            dataIndex: 'enterpriseDepartmentName',
            key: 'enterpriseDepartmentName',
            // sorter: true,
            width: 140,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
            // sorter: true,
            width: 100,
        },{
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 80,
        },{
            title: '城市',
            dataIndex: 'workCity',
            key: 'workCity',
            // sorter: true,
            width: 80,
        }, {
            title: '主管领导工号',
            dataIndex: 'leaderCode',
            key: 'leaderCode',
            // sorter: true,
            width: 100,
        }, {
            title: '主管领导姓名',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 80,
        }, {
            title: '状态',
            dataIndex: 'workStatus',
            key: 'workStatus',
            width: 60,
        }, {
            title: '中文简历最近更新日期',
            dataIndex: 'cnVitaeLastModifyDateShow',
            key: 'cnVitaeLastModifyDateShow',
            sorter: true,
            width: 100,
            render: this.getDateRender,
        },{
            title: '英文简历最近更新日期',
            dataIndex: 'enVitaeLastModifyDateShow',
            key: 'enVitaeLastModifyDateShow',
            sorter: true,
            width: 100,
            render: this.getDateRender,
        },{
            title: '最近审核通过日期',
            dataIndex: 'lastApprovalDateShow',
            key: 'lastApprovalDateShow',
            sorter: true,
            width: 100,
            render: this.getDateRender,
        }, {
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 80,
            fixed: 'right',
            render: (text, record) => {
                return <a onClick={() => this.showVitae(record)}>查看简历</a>
            }
        }];
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus } = item;
            return {
                index: (current - 1) * pageSize + index + 1,
                ...item,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    showVitae = (record) => {
        const { curRole } = sessionStorage; 
        const { userId, workStatus, userCompellation } = record;
        this.props.saveParams({
            userId,
            userName: userCompellation,
            isChinese: true,
            canEdit: workStatus === '在职' && (curRole !== 'FIN'),
            showModal :false,
        });
        location.href = `./#/user/curriculumVitae`;
    }

    showPreviewModal = userId => {
        this.previewModalRef.show(userId);
    }

    render() {
        const { loading, pagination, sortParams } = this.state;
        const { noticeParams = {} } = this.props;
        return (
            <div className="content">
                <UserSider selectKey='userResume' openKeys={['sub1']}/>
                <div className='main'>
                    <Filter search={this.search} export={this.export}  noticeParams={noticeParams}/>
                    <TableC
                        loading={loading}
                        pagination={pagination}
                        sortParams={sortParams}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        onChange={this.handleTableChange}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        noticeParams: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
        saveNoticeParams: (params) => dispatch(saveNoticeParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserResume);


// WEBPACK FOOTER //
// ./src/components/user/UserResume.js